import { render, staticRenderFns } from "./document-form-text.vue?vue&type=template&id=27c288fe&scoped=true&"
import script from "./document-form-text.vue?vue&type=script&lang=js&"
export * from "./document-form-text.vue?vue&type=script&lang=js&"
import style0 from "./document-form-text.vue?vue&type=style&index=0&id=27c288fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c288fe",
  null
  
)

export default component.exports